module.exports = __webpack_public_path__ + "static/media/PayPal-payment.1187a17c.png";